import { gql } from '@apollo/client';

export const FETCH_BONDS = gql`
  query fetchBonds($order: BondOrder, $first: Int, $filter: [String!]) {
    bonds(order: $order, first: $first, filter: $filter) {
      bondMarketStatus
      nodes {
        id
        symbol
        exchangeSymbol
        bid
        bidYield
        ask
        askYield
        last
        lastTradeDate
        lastYield
        lastDuration
        updatedUtc
        intradayAccumulatedTurnover
        intradayHighPrice
        intradayNumberOfTrades
        intradayPerChange
        intradayNetChange
        details {
          isLinkedToIcelandicCPI
        }
      }
    }
  }
`;
